
/* eslint 'no-self-assign' : 'off', eqeqeq : 'off'  */

import React, { Component } from 'react';
import { connect } from "react-redux";
import { FormGroup, Label, Form, Table, Button } from 'reactstrap';
import EditSetting from '../_ModalsForms/EditWorkOrderSetup';
import AddEditCustomFieldSetup from '../_ModalsForms/AddEditCustomFieldSetup';
import {GetStandardFields,SaveStandardFieldsInitialSetup,SaveWorkOrderMailAddresses,GetWorkOrderMailAddresses, GetServiceRequestSetupDetails } from '../../../../action/workorderAction';
import { setAmplitudeEvent } from 'amplitude/amplitude';
import CustomFields from './CustomFields';

const headinglabel = {
    fontfamily: 'Verdana',
    fontSize: '14px',
    fontWeight: 'bold',
    'margin-left':'15px'
};

class WorkOrderSetup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sort: {
                column: null,
                direction: [
                    { name: 'field', direction: 'desc', onclick: false },
                    { name: 'fieldLabel', direction: 'desc', onclick: false },
                    { name: 'type', direction: 'desc', onclick: false },
                    { name: 'shortValue', direction: 'desc', onclick: true },
                    { name: 'required', direction: 'desc', onclick: false },
                    { name: 'display', direction: 'desc', onclick: false }
                ]
            },
            Options_List_Value : [],
            editmodal:false,
            selectedRowId: 0,
            selectedRow:[],
            IsInitial:false,
            IsDefaultSort: true,
            isAddCustom: false,
            CustomFieldId : -1,
            IsMailAddressEdit: false,
            MailAddresses: '',
            IsMailError: false
        };
        this.EditSetup = this.EditSetup.bind(this);
        this.Edittoggle = this.Edittoggle.bind(this);
        this.SaveInitialSetup = this.SaveInitialSetup.bind(this);
    }

    componentWillMount() {
        this.props.GetStandardFields();
        this.props.GetWorkOrderMailAddresses();
        this.props.GetServiceRequestSetupDetails()
    }

    componentWillReceiveProps(nextProps) {
        let label = this.props.getLabels;

        // var Status = label['WorkOrders.Status.Text'].split(',');
        // var status_values = Status.map((el,i) => ({
        //     key: el,
        //     value: label['WorkOrders.Status.'+el+'.Text'],
        //     isCustom: false,
        //     orderId: el == 6 ? 999 : i
        // }
        // ));
        // var status_short = status_values.map(el => (
        //     el.value
        // ));

        // var status_short_text = status_short.join(', ').substring(0, 30) + (status_short.join(', ').length > 30 ? "..." : "")

        // var Urgency = label['WorkOrders.Urgency.Text'].split(',');
        // var urgency_value = Urgency.map((el,i) => ({
        //     key: el,
        //     value:label['WorkOrders.Urgency.'+el+'.Text'],
        //     isCustom: false,
        //     orderId: i
        // }
        // ));
        // var urgency_short = urgency_value.map(el => (
        //     el.value
        // ));

        // var urgency_short_text = urgency_short.join(', ').substring(0, 30) + (urgency_short.join(', ').length > 30 ? "..." : "")

        // var Problems = label['WorkOrders.Problem.Text'].split(',');
        // var problems_values = Problems.map((el,i) => ({
        //     key: el,
        //     value: label['WorkOrders.Problem.'+el+'.Text'],
        //     isCustom: false,
        //     orderId: i
        // }
        // ));
        // var problem_short = problems_values.map(el => (
        //     el.value
        // ));

        // var problem_short_text = problem_short.join(', ').substring(0, 30) + (problem_short.join(', ').length > 30 ? "..." : "")
        // var optional_values = [];
        // var optional_short_text = [];

        // var Options = label['WorkOrderSetup.Options.Text'].split(',');
        // var Options_Value = Options.map(el => (
        //     {
        //         field: label['WorkOrderSetup.Options.' + el + '.Text'],
        //         fieldLabel: label['WorkOrderSetup.Options.' + el + '.Text'],
        //         fieldId: el,
        //         type: (el <= 12 && el != 4 && el != 11) ? label['WorkOrderSetup.SingleDropdown.Text'] : (el == 4) ? label['WorkOrderSetup.Auto.Text'] : (el == 11) ? label['WorkOrderSetup.TextArea.Text'] : "--",
        //         value: el == 1 ? status_values : el == 3 ? urgency_value : el == 9 ? problems_values :el == 12 ? optional_values : "--",
        //         shortValue: el == 1 ? status_short_text : el == 3 ? urgency_short_text : el == 9 ? problem_short_text : el == 12 ? optional_short_text : "--",
        //         display: true,
        //         required: false
        //     }
        // ));

        if(this.props !== nextProps && nextProps.getMailAddresses !== undefined){
            this.setState({ MailAddresses : nextProps.getMailAddresses });
        }

        if(this.props !== nextProps && nextProps.AddCustomModal.modal_open !== undefined){
            this.setState({isAddCustom : nextProps.AddCustomModal.modal_open , CustomFieldId : nextProps.AddCustomModal.CustomFieldId});            
        }

        if (this.props != nextProps && nextProps.getStandardFields != undefined && nextProps.getStandardFields.length > 0) {

            var fieldsFromDB = nextProps.getStandardFields.filter(x => x.isHidden == 0);
            fieldsFromDB.forEach(fields => {
                fields.fieldLabel = (fields.fieldLabel != "") ? fields.fieldLabel : label['WorkOrderSetup.Options.' + fields.fieldId + '.Text'];
                if(fields.value.length > 0)
                {
                    fields.value.forEach(el => {
                        if(fields.fieldId == 1 && el.isCustom == false && el.value == "")
                        {
                            el.value = label['WorkOrders.Status.'+el.key+'.Text'];
                        }
                        if(fields.fieldId == 3 && el.isCustom == false && el.value == "")
                        {
                            el.value = label['WorkOrders.Urgency.'+el.key+'.Text'];
                        }
                        if(fields.fieldId == 9 && el.isCustom == false && el.value == "")
                        {
                            el.value = label['WorkOrders.Problem.'+el.key+'.Text'];
                        }
                    });
                }
            });

            var setup_values = fieldsFromDB.map(el => ({
                field: el.field,
                fieldLabel: el.fieldLabel,
                fieldId: el.fieldId,
                type: (el.fieldId <= 12 && el.fieldId != 4 && el.fieldId != 11) ? label['WorkOrderSetup.SingleDropdown.Text'] : (el.fieldId == 4) ? label['WorkOrderSetup.Auto.Text'] : (el.fieldId == 11 || 13) ? label['WorkOrderSetup.TextArea.Text'] : "--",
                value: el.value.length > 0 ? el.value : "--",
                shortValue: "--",
                display: el.display ,
                required: el.required,
                displayOnWOForm: el.isServiceRequestFormField,
            }));

            setup_values.forEach(el => {
                if (el.value != "--") {
                    let sortedData = el.value.sort((a, b) => {
                        var nameA = a['orderId'];
                        var nameB = b['orderId'];
                        if (nameA < nameB) { return -1; }
                        if (nameA > nameB) { return 1; }
                        if (nameA == nameB) { return 0; }
                        return 0;
                    });
                    var short_text = sortedData.map(el => (
                        el.value
                    ));
                    el.shortValue = short_text.join(', ').substring(0, 30) + (short_text.join(', ').length > 30 ? "..." : "")
                }
            });

            this.setState({ Options_List_Value: setup_values,IsInitial:false });
        }
        // else{
        //         this.setState({ Options_List_Value: Options_Value,IsInitial:true });  
        // }   
    }

    Edittoggle() {
        this.setState({
            editmodal: !this.state.editmodal
        });
    }

    EditSetup(e) {

        var l_row = this.state.Options_List_Value.filter(x => x.fieldId == e)[0];
        var l_rowValue = [];
        if (l_row.value != "--") {
            l_rowValue = l_row.value.map((el, i) => ({
                key: el.key,
                value: el.value,
                isCustom: el.isCustom,
                index: i,
                orderId:el.orderId
            }));
            l_row.value = l_rowValue;
        }
        this.setState({
            selectedRowId: e,
            selectedRow: l_row
        });
        this.Edittoggle();
    }

    async SaveInitialSetup() {
        var l_InitialSetup = [];

        this.state.Options_List_Value.forEach(element => {
            var l_value = [];
            if (element.value != "--") {
                element.value.forEach(el => {
                    l_value.push(el)
                });
            }

            var lineItem = {
                "field": element.field,
                "fieldLabel": element.fieldLabel,
                "fieldId": element.fieldId,
                "value": l_value,
                "display": element.display,
                "required": element.required,
            }
            l_InitialSetup.push(lineItem);
        });

        await this.props.SaveStandardFieldsInitialSetup(l_InitialSetup);
    }

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        const SelectedDirectioninfo = this.state.sort.direction.filter(x => x.name == column)[0];
        const direction = SelectedDirectioninfo !== null ? (SelectedDirectioninfo.direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.Options_List_Value;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.state.Options_List_Value.sort((a, b) => {
            var nameA = a[column];
            var nameB = b[column];

            if (isNaN(a[column])) {
                nameA = a[column].toLowerCase();
                nameB = b[column].toLowerCase();
            }
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(SelectedDirectioninfo.direction =='asc' && notequals == 1){
        sortedData.reverse();
     }
     const array = this.state.sort.direction;
     array.map(x => (x.name == column) ? x.onclick = true : x.onclick = false);
     array.map(x => (x.name == column) ? x.direction = direction : x.direction = x.direction);

        this.setState({
            temp_adjustments_list_state: sortedData,
            sort: {
                column,
                direction: array
            }
        });
       }
    };

    OnCancelMailSetup = () =>{
        this.setState({ IsMailAddressEdit : false })
    }

    OnAddEmailAddress = () =>{
        this.setState({ IsMailAddressEdit : true, IsMailError : false })
    }

    OnSaveEmailAddress = () =>{
        this.setState({ IsMailError : false });
        var l_MailAddresses = this.refs.txt_Setup_MailAddress.value.trim();
        
        var IsValid = true;
        let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var EmailIds = this.refs.txt_Setup_MailAddress.value; 
        var Ids = EmailIds.trim().toLowerCase().split(/\s*;\s*/);
        for(let i=0; i<Ids.length; i++){
            var MailId = Ids[i];
            if(MailId !== "" && !MailId.match(Email)){
                IsValid = false;
            }
        }
        if(IsValid){
            const uniqueMailIds = Ids.filter((val,id,array) => array.indexOf(val) === id).filter(val => val !== "")
            setAmplitudeEvent("WO/PM Email Notifications",{"WO Emails":uniqueMailIds.length});
            this.props.SaveWorkOrderMailAddresses({"MailAddress" : l_MailAddresses});
            this.setState({ IsMailAddressEdit : false })
        }
        else{
            this.setState({ IsMailError : true });
        }
    }

    render(){
        let label = this.props.getLabels;
        let isWOFormEnabled = this.props.getServiceRequestDetails.length ? this.props.getServiceRequestDetails[0].isServiceRequestEnabled : false;
        //var Problems = label['WorkOrders.Problem.Text'].split(',');
        // var problems_values = Problems.map(el => (
        //     label['WorkOrders.Problem.'+el+'.Text']
        // ));

        //var Status = label['WorkOrders.Status.Text'].split(',');
        // var status_values = Status.map(el => (
        //     label['WorkOrders.Status.'+el+'.Text']
        // ));

        //var Urgency = label['WorkOrders.Urgency.Text'].split(',');
        // var urgency_value = Urgency.map(el => (
        //     label['WorkOrders.Urgency.'+el+'.Text']
        // ));

        if(this.state.Options_List_Value !== undefined && this.state.Options_List_Value !== null && this.state.Options_List_Value.length && this.state.IsDefaultSort){
            //eslint-disable-next-line
            const sortedData = this.state.Options_List_Value.sort((a, b) => {
                var nameA = a['shortValue'];
                var nameB = b['shortValue'];
    
                if (isNaN(a['shortValue'])) {
                    nameA = a['shortValue'].toLowerCase();
                    nameB = b['shortValue'].toLowerCase();
                }
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
        }

        var data = this.state.Options_List_Value.map(el => (
            <tr key={el.fieldId}>
                <td><Label className="link_cursorUnderline" onClick={() => {this.EditSetup(el.fieldId)}} >{label['WorkOrderSetup.Options.'+el.fieldId+'.Text']}</Label></td>
                <td>{el.field != el.fieldLabel ? el.fieldLabel : el.field}</td>
                <td>{el.type}</td>
                <td>{el.shortValue}</td>
                <td>{el.required ? label['WorkOrderSetup.Yes.Text'] : label['WorkOrderSetup.No.Text']}</td>
                <td>{ el.display == true ? label['WorkOrderSetup.Yes.Text'] : label['WorkOrderSetup.No.Text']}</td>
            </tr>
        ));

        return(
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
            <div className="border_container">
                <div className="main_container">
                { this.state.isAddCustom === true ? <AddEditCustomFieldSetup CustomFieldID={this.state.CustomFieldId} close={this.Edittoggle} FieldName="FieldLabel1" isWOFormEnabled={isWOFormEnabled} Premise={this.props.Premise}/>
                :
                    this.state.editmodal == false ?
                <div>
                    <div className="div_Setup_Email">
                    {
                        this.state.IsMailAddressEdit ?
                        <p>
                            <Label className="LblHeader_Setup_Email">Work Order Email Notifications</Label>
                            <Button className="btn_Setup_Action_Email_success" style={{"background": "rgb(76, 145, 45)"}} onClick={this.OnSaveEmailAddress}>Save</Button>
                            <Button className="btn_Setup_Action_Email_cancel" style={{"margin-right":"7px"}} onClick={this.OnCancelMailSetup}>Cancel</Button>
                            <br/>
                            <Label className="Lbltitle_Setup_Email">Send email notification for every Work Order that is created and closed.</Label>
                            <Label className="lbl_subtitle_Setup_Email">Email</Label><span className="span_Setup_Email"> (opt.)</span>
                            <textarea className={!this.state.IsMailError ? "textarea_Setup_Email" : "textarea_Setup_Email textarea_Setup_EmailError"} ref="txt_Setup_MailAddress" defaultValue={this.state.MailAddresses} />
                            <span className="span_Setup_EmailNotification">Type additional addresses using semi-colons to separate each address.</span>
                        </p> : (this.state.MailAddresses !== "" && this.state.MailAddresses !== null) ? 
                        <p>
                            <Label className="LblHeader_Setup_Email">Work Order Email Notifications</Label>
                            <Button className="btn_Setup_Email" onClick={this.OnAddEmailAddress}>Edit</Button>
                            <br/>
                            <Label className="Lbltitle_Setup_Email">Send email notification for every Work Order that is created and closed.</Label>
                            <Label className="lbl_Setup_SavedEmailHeader">Email</Label><br/>
                            <Label className="lbl_Setup_SavedEmail">{this.state.MailAddresses}</Label>
                        </p> :
                        <p>
                            <Label className="LblHeader_Setup_Email">Work Order Email Notifications</Label>
                            <Button className="btn_Setup_Email" onClick={this.OnAddEmailAddress}>Add Email</Button>
                            <br/>
                            <Label className="Lbltitle_Setup_Email">Send email notification for every Work Order that is created and closed.</Label>
                        </p>
                    }  
                    </div>
                <Form>
                    <FormGroup style={{"margin-bottom":"0px"}}>
                        <Label style={headinglabel}>{label['WorkOrderSetup.StandardField.Text']}</Label>
                    </FormGroup>
                    <FormGroup>
                        <Label style={{'margin-left':'15px'}}>{label['WorkOrderSetup.UIText.Text']}</Label>
                    </FormGroup>
                </Form>
                
                <div className="table_container table_border">
                    <Table striped responsive className=" Custom_table fixed_layout">
                        <tbody  className="cell_container">
                            <tr>
                                <th onClick={this.onSort('field')} className="wo_cursor">
                                    <span>{label['WorkOrderSetup.Header.FieldName.Text']}</span>
                                    <span className={(this.state.sort.direction[0].name == "field") ?
                                        (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('fieldLabel')} className="wo_cursor">
                                    <span>{label['WorkOrderSetup.Header.FieldLabel.Text']}</span>
                                    <span className={(this.state.sort.direction[1].name == "fieldLabel") ?
                                        (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>   
                                </th>
                                <th onClick={this.onSort('type')} className="wo_cursor">
                                    <span>{label['WorkOrderSetup.Header.FieldType.Text']}</span>
                                    <span className={(this.state.sort.direction[2].name == "type") ?
                                        (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('shortValue')} className="wo_cursor">
                                    <span>{label['WorkOrderSetup.Header.Values.Text']}</span>
                                    <span className={(this.state.sort.direction[3].name == "shortValue") ?
                                        (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('required')} className="wo_cursor">
                                    <span>{label['WorkOrderSetup.Header.Required.Text']}</span>
                                    <span className={(this.state.sort.direction[4].name == "required") ?
                                        (this.state.sort.direction[4].onclick) ? (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('display')} className="wo_cursor">
                                    <span>{label['WorkOrderSetup.Header.DisplayOnPage.Text']}</span>
                                    <span className={(this.state.sort.direction[5].name == "display") ?
                                        (this.state.sort.direction[5].onclick) ? (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                            </tr>
                            {data}
                        </tbody>
                    </Table>
                </div>
                <CustomFields isWOFormEnabled={isWOFormEnabled}/>
            </div> : <EditSetting id={this.state.selectedRowId} values={JSON.stringify(this.state.selectedRow)} close={this.Edittoggle} isInitialSetup={this.state.IsInitial} fromWorkOrder={true} SaveInitial={this.SaveInitialSetup} isWOFormEnabled={isWOFormEnabled}/>
            }
            </div>
            </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getStandardFields : state.WorkorderRootReducer.WorkOrderStandardFields,
        AddCustomModal : state.WorkorderRootReducer.AddCutomModalOpenClose,
        getMailAddresses : state.WorkorderRootReducer.WorkOrderSetupMailAddresses,
        getServiceRequestDetails: state.WorkorderRootReducer.ServiceRequestSetUpDetails, 
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetStandardFields : () => dispatch(GetStandardFields()),
        SaveStandardFieldsInitialSetup: (data) => dispatch(SaveStandardFieldsInitialSetup(data)),
        SaveWorkOrderMailAddresses: (data) => dispatch(SaveWorkOrderMailAddresses(data)),
        GetWorkOrderMailAddresses : () => dispatch(GetWorkOrderMailAddresses()),
        GetServiceRequestSetupDetails: () => dispatch(GetServiceRequestSetupDetails()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderSetup);